import React, { useEffect, useState } from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import Swal from "sweetalert2";
import { GetASD, GroupByForeignKey, GroupByPropCheck, GroupByProps } from "../ReporteCobranza/Actions/GetContainer";
import { EjercicioByRange } from "../ReporteCobranza/Helper/EjercicioByRange";
import { PeriodoSelect } from "../ReporteCobranza/Helper/PeriodoSelect";
import { TipoSelect } from "../../Dashboard/Vendedor/Helper/TipoSelect";
import { TipoCartera } from "../ReporteCobranza/Helper/TipoCartera";

const FiltroTotalCartera = ({
  onExecute,
  boxState,
  onBoxChange,
  cargarfiltros = true,
  linea,
  cartera,
  sucursales
}) => {
  const [openModal, setOpenModal] = useState(false);
  const storedState = JSON.parse(localStorage.getItem('state')) || {};
  const [state, setState] = useState({
    responsable: storedState.responsable === 'CC' ? 'CCCC' :
      storedState.responsable === 'EC' ? 'EJEC' :
        storedState.responsable === 'CS' ? 'COBS' :
          storedState.responsable === 'CN' ? 'COBN' :
            storedState.responsable === 'GC' ? 'COBG' :
              storedState.responsable || 'CCCC',
    linea: linea || storedState.linea || 'C',
    cartera: cartera || storedState.cartera || 'C',
    gestion: storedState.gestion || 'C',
    adr: (storedState.adr ? storedState.adr.filter(item => item.checked).map(({ idadr, adr }) => ({ idadr, adr })) : []),
    sucursal: (storedState.sucursal ? storedState.sucursal.filter(item => item.checked).map(({ idsucursal, sucursal }) => ({ idsucursal, sucursal })) : []),
    ejercicio: storedState.ejercicio || new Date().getFullYear(),
    periodo: storedState.periodo || new Date().getMonth() + 1,
    tipo: "R",
    tipoCartera: "A",
    lineas: []
  });
  const {
    data,
    adr,
    sucursal,
    departamento,
    tipo,
    tipoCartera,
    lineas
  } = state;
  const onOpenModal = () => {
    const container = document.getElementById("mdlFiltros-modal");
    if (!container) return;
    if (openModal) {
      container.style.display = "flex";
      setOpenModal(false);
    } else {
      container.style.display = "none";
      setOpenModal(true);
    }
  };

  const guardarState = (nuevoState) => {
    // Obtener el estado actual de localStorage
    const storedState = JSON.parse(localStorage.getItem("state")) || {};

    // Actualizar solo las claves necesarias y mantener las demás
    const updatedState = {
      ...storedState,  // Mantiene los datos existentes
      periodo: nuevoState.periodo,
      ejercicio: nuevoState.ejercicio,
      sucursal: nuevoState.sucursal,
      adr: nuevoState.adr,
      responsable: nuevoState.responsable,
      linea: nuevoState.linea,
      cartera: nuevoState.cartera,
      gestion: nuevoState.gestion
    };

    // Guardar el nuevo estado en localStorage
    // localStorage.setItem("state", JSON.stringify(updatedState));
  };

  useEffect(() => {
    // onClose();
    if (cargarfiltros)
      GetASD()
        .then((res) => {
          setState({
            ...state,
            data: res,
          });
          let sucursalesSeleccionadas = boxState?.pv?.sucursal?.length > 0
            ? boxState.pv.sucursal
            : sucursales.map(s => ({ idsucursal: s.idsucursal, sucursal: s.sucursal || s.nombreSucursal || "" }));
          onBoxChange("pv", {
            adr: GroupByProps(res, ["idadr", "adr"]),
            sucursal: sucursalesSeleccionadas,
            departamento: [],
          });
        })
        .catch((err) => console.log(err));
  }, []);

  const idsSucursalPermitidas = [...new Set(sucursales?.map(s => String(s.idsucursal)))];

  const sucursalFiltrada = sucursal.filter(item => idsSucursalPermitidas.includes(item.idsucursal));

  const adrFiltrado = adr?.filter(itemAdr =>
    data?.some(d => String(d.idadr) === String(itemAdr.idadr) && idsSucursalPermitidas.includes(String(d.idsucursal)))
  );

  // console.log(state)
  useEffect(() => {
    if (!data || data.length === 0) return;

    var newadr = GroupByPropCheck(data, ["idadr", "adr"]);
    var newsucursal = GroupByPropCheck(data, ["idsucursal", "sucursal"], false);
    var newdepartamento = GroupByPropCheck(data, ["iddepartamento", "departamento"], false);

    // Aplicar el estado checked guardado en localStorage si existe
    const savedState = JSON.parse(localStorage.getItem("state")) || {};

    if (savedState.adr && savedState.adr.length > 0) {
      newadr = newadr.map((item) => ({
        ...item,
        checked: savedState?.adr?.some((a) => a.idadr === item.idadr && a.checked),
      }));
    }

    if (savedState.sucursal && savedState.sucursal.length > 0) {
      newsucursal = newsucursal.map((item) => ({
        ...item,
        checked: savedState?.sucursal?.some((s) => s.idsucursal === item.idsucursal && s.checked),
      }));
    }

    setState({
      ...state,
      adr: newadr,
      sucursal: newsucursal,
      departamento: newdepartamento,
    });
  }, [data]);

  // console.log(state)
  const onCargar = () => {
    onOpenModal();
    // guardarState(state);
    onExecute(state.sucursal, state.adr)
      .then((result) => {
      })
      .catch((error) => {
        Swal.fire("RESUMEN DE CARTERA MENSUAL", JSON.stringify(error), "error");
        console.log(error)
      });
  };

  const labelclick = ({ target }) => {
    target.parentNode.firstChild.click();
  };

  const selectedClick = ({ target }, index) => {
    switch (target.name) {
      case "chk-adr":
        var newarray = adr;
        newarray[index].checked = target.checked;

        var newarrarsucursal = [];
        var newarraydepartamento = [];
        var adrActive = [];
        newarray.forEach((item) => {
          if (item.checked) {
            adrActive = [...adrActive, { idadr: item.idadr, adr: item.adr }];
            newarrarsucursal = newarrarsucursal.concat(
              GroupByForeignKey(data, "idadr", item.idadr, [
                "idsucursal",
                "sucursal",
              ])
            );
            newarraydepartamento = newarraydepartamento.concat(
              GroupByForeignKey(data, "idadr", item.idadr, [
                "iddepartamento",
                "departamento",
              ])
            );
          }
        });
        onBoxChange("pv", {
          adr: adrActive,
          sucursal: [],
          departamento: [],
        });
        setState({
          ...state,
          adr: newarray,
          sucursal:
            newarrarsucursal.length == 0
              ? GroupByPropCheck(data, ["idsucursal", "sucursal"], false)
              : GroupByPropCheck(
                newarrarsucursal,
                ["idsucursal", "sucursal"],
                false
              ),
          departamento:
            newarraydepartamento.length == 0
              ? GroupByPropCheck(
                data,
                ["iddepartamento", "departamento"],
                false
              )
              : GroupByPropCheck(
                newarraydepartamento,
                ["iddepartamento", "departamento"],
                false
              ),
        });
        break;
      case "chk-sucursal":
        var newarray = sucursalFiltrada;
        newarray[index].checked = target.checked;

        var newarraydepartamento = [];
        var sucursalactiva = [];
        newarray.forEach((item) => {
          if (item.checked) {
            sucursalactiva = [
              ...sucursalactiva,
              { idsucursal: item.idsucursal, sucursal: item.sucursal },
            ];
            newarraydepartamento = newarraydepartamento.concat(
              GroupByForeignKey(data, "idsucursal", item.idsucursal, [
                "iddepartamento",
                "departamento",
              ])
            );
          }
        });
        onBoxChange("pv", {
          adr: boxState.pv.adr,
          sucursal: sucursalactiva,
          departamento: [],
        });
        setState({
          ...state,
          sucursal: newarray,
          departamento:
            newarraydepartamento.length == 0
              ? GroupByPropCheck(
                data,
                ["iddepartamento", "departamento"],
                false
              )
              : GroupByPropCheck(
                newarraydepartamento,
                ["iddepartamento", "departamento"],
                false
              ),
        });
        break;
      case "chk-linea":
        var newarray = [...state.linea]; // Clonar el array actual

        const value = target.value; // "taller", "diversos", etc.
        const checked = target.checked;

        // Buscar si ya existe en el array
        const existingIndex = newarray.findIndex((item) => item.linea === value);

        if (existingIndex > -1) {
          // Ya existe, solo actualiza el checked
          newarray[existingIndex].checked = checked;
        } else {
          // No existe, agregarla
          let idLineaValue = value.toLowerCase() === "juridico" ? "A" : value.charAt(0).toUpperCase();

          newarray.push({
            idlinea: idLineaValue,
            linea: value,
            checked: checked,
          });
        }

        // Filtrar las activas
        const lineasActivas = newarray.filter((item) => item.checked);

        // Buscar los departamentos relacionados con las líneas activas
        let newarraydepartamentos = [];
        lineasActivas.forEach((item) => {
          newarraydepartamentos = newarraydepartamentos.concat(
            GroupByForeignKey(data, "linea", item.linea, [
              "iddepartamento",
              "departamento",
            ])
          );
        });

        onBoxChange("pv", {
          adr: boxState.pv.adr,
          sucursal: boxState.pv.sucursal,
          linea: lineasActivas,
          departamento: [],
        });

        setState({
          ...state,
          linea: newarray,
          departamento:
            newarraydepartamentos.length === 0
              ? GroupByPropCheck(data, ["iddepartamento", "departamento"], false)
              : GroupByPropCheck(
                newarraydepartamentos,
                ["iddepartamento", "departamento"],
                false
              ),
        });
        break;

      default:
        var newarray = departamento;
        var departamentoactivo = [];
        newarray[index].checked = target.checked;

        newarray.forEach((item) => {
          if (item.checked) {
            departamentoactivo = [
              ...departamentoactivo,
              {
                iddepartamento: item.iddepartamento,
                departamento: item.departamento,
              },
            ];
          }
        });
        onBoxChange("pv", {
          adr: boxState.pv.adr,
          sucursal: boxState.pv.sucursal,
          departamento: departamentoactivo,
        });
        setState({
          ...state,
          departamento: newarray,
        });
        break;
    }
  };

  const onChange = ({ target }) => {
    setState({
      ...state,
      [target.name]: target.value,
    });
    onBoxChange(target.name, target.value);
  };

  // console.log(openModal)

  return (
    <div className="filtros-gestion-cobranza">
      <div className="reporte-buro-credito-filtrado" onClick={onOpenModal}>
        <FilterAltIcon /> Filtrar
      </div>
      <div className="mdl-filtro-resumen-cartera" id="mdlFiltros-modal">
        <PlantillaScreen
          titulo={`Filtro`}
          className_main={1}
          className={"modal-filtro-resumen-cartera-mensual"}
        >
          <div className="filtro-soy-el-titulo-header" onClick={onOpenModal}>
            X
          </div>
          <div className="modal-filtro-resumen-cartera-mensual-container">
            <div className="modal-filtro-resumen-cartera-mensual-container-filtros">
              <div className="filtro-tiempo-tipo">
                <div className="filtro-group">
                  <div className="filtro-group">
                    <label>Cartera</label>
                    <TipoSelect name="tipo" value={tipo} onChange={onChange} />
                  </div>

                  {tipo === "D" && (
                    <div className="filtro-group">
                      <label>Visualizar</label>
                      <TipoCartera name="tipoCartera" value={tipoCartera} onChange={onChange} />
                    </div>
                  )}

                  {tipoCartera === "C" && (
                    <>
                      <label>Ejercicio</label>
                      <EjercicioByRange
                        name="ejercicio"
                        value={state.ejercicio}
                        onChange={onChange}
                      />
                      <label>Periodo</label>
                      <PeriodoSelect
                        name="periodo"
                        value={state.periodo}
                        onChange={onChange}
                      />
                    </>
                  )}
                </div>
                <div
                  className="mdlFiltros-modal-acciones-guardar"
                  onClick={onCargar}
                >
                  Cargar
                </div>
              </div>
              <div className="filtro-adr">
                <div className="title title-adr">REGION</div>
                {adrFiltrado.map((item, index) => (
                  <div key={`${item}-${index}`} className="chk-groups">
                    <input
                      type="checkbox"
                      name="chk-adr"
                      onChange={(e) => selectedClick(e, index)}
                      checked={item.checked}
                      value={item.idadr}
                    />
                    <label>{item.adr}</label>
                  </div>
                ))}
              </div>
              <div className="filtro-sucursal">
                <div className="title-sucursal">SUCURSAL</div>
                {sucursalFiltrada.map((item, index) => (
                  <div key={`${item}-${index}`} className="chk-groups">
                    <input
                      type="checkbox"
                      name="chk-sucursal"
                      className="my-checkbox"
                      onChange={(e) => selectedClick(e, index)}
                      checked={item.checked}
                      value={item.idsucursal}
                    />
                    <label onClick={labelclick}>{item.sucursal}</label>
                  </div>
                ))}
              </div>

              {state.tipo === "D" && (
                <div className="filtro-sucursal">
                  <div className="title-sucursal">LINEA</div>
                  {["taller", "diversos", "refacciones", "juridico", "jdf", "ventas"].map((item, index) => (
                    <div key={`${item}-${index}`} className="chk-groups">
                      <input
                        type="checkbox"
                        name="chk-linea"
                        className="my-checkbox"
                        onChange={(e) => selectedClick(e, index)}
                        value={item}
                      />
                      <label onClick={labelclick}>{item}</label>
                    </div>
                  ))}
                </div>
              )}

            </div>
            <div className="mdlFiltros-modal-acciones">
            </div>
          </div>
        </PlantillaScreen>
      </div>
    </div>
  );
};

export default FiltroTotalCartera;
